// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"28bbc974","37":"4336f566","90":"462eb282","142":"e285892a","351":"85a7d9af","707":"14b4c335","840":"cd8a836b","953":"dd656af6"}[chunkId] + ".chunk.js";
};